import { useAtom } from 'jotai';

import {
  upgradeModalAtom,
  type UpgradeFeature,
  type UpgradeTier,
} from '@/atoms/upgradeModalAtom';

export const useUpgradeModal = () => {
  const [state, setState] = useAtom(upgradeModalAtom);

  const open = (feature: UpgradeFeature, tier: UpgradeTier = 'plus') =>
    setState({ isOpen: true, feature, tier });
  const close = () => setState((current) => ({ ...current, isOpen: false }));

  return { ...state, open, close };
};
